// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--rLNBC";
export var intro = "Footer-module--intro--Ntrr3";
export var list = "Footer-module--list---ibYT";
export var pageContent = "Footer-module--page-content--ZzP-h";
export var sectionSpacingB = "Footer-module--section-spacing-b--9rBa2";
export var sectionSpacingT = "Footer-module--section-spacing-t--fFflg";